/**
 * Empty Cart Component
 *
 * Displayed when the cart has no items.
 */

import { Link } from 'react-router';
import { ShoppingBag } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface EmptyCartProps {
    onClose?: () => void;
}

export const EmptyCart = ({ onClose }: EmptyCartProps) => {
    return (
        <div className="delight-rise flex flex-col items-center justify-center py-12 px-4 text-center">
            <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mb-4">
                <ShoppingBag className="h-8 w-8 text-muted-foreground/70" />
            </div>
            <h3 className="text-lg font-medium text-foreground mb-2">
                Your cart is empty
            </h3>
            <p className="text-sm text-muted-foreground mb-6 max-w-xs">
                You haven&apos;t added any baby equipment yet.
                Browse the catalogue to add rentals or subscription items.
            </p>
            <Link to="/catalogue" onClick={onClose}>
                <Button>Browse baby equipment</Button>
            </Link>
        </div>
    );
};

export default EmptyCart;
